export const publicRoutes = {
  home: () => '/',
  login: () => '/auth/login',
  signup: () => '/auth/signup',
  phone: () => '/auth/phone',
  confirmationEmail: (email: string) => `/auth/confirm/status?email=${email}`,
  forgotPassword: () => '/auth/forgot-password',
  forgotPasswordCheckEmail: () => '/auth/forgot-password/check-email',
  comeBackSoon: () => '/come-back-soon',
  publicHunt: (slug: string) => `/h/${slug}`,
  publicTreasure: (slug: string, treasureId: string) => `/h/${slug}/t/${treasureId}`,
};
